import { Theme, alpha } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'applications-admin',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    panel: {},
    dialog: {},
    listItem: {
      borderRadius: 4,
      padding: theme.spacing(1),
      alignItems: 'flex-start',
      '&:nth-child(odd)': {
        backgroundColor: alpha(theme.palette.primary.main, 0.05),
      },
    },
    list: {},
  }),
  options
);

export default useStyles;
